// import 'devextreme/dist/css/dx.light.css';
// import 'devextreme/dist/css/dx.common.css';

// import './themes/generated/theme.base.css';
// import './themes/generated/theme.additional.css';
import './themes/generated/overrides.scss';
import './themes/generated/theme.printstat.css';
import VueRouterReferer from "@tozd/vue-router-referer";

import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import { getConfig } from "./services/api";

Vue.config.productionTip = false;
Vue.use(VueRouterReferer);

import ServerEventsPlugin from "./plugins/server-events-plugin";
import i18n from './i18n'
Vue.use(ServerEventsPlugin);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");


// Загрузить адреса приложения и бэкенда из файла config.json
// Файл должен находиться в корне приложения
async function initApi() {
  const config = await getConfig();

  if (config.API) {
    store.commit("setApiPath", config.API);
  }
  if (config.WS) {
    store.commit("setWsPath", config.WS);
  }
}

initApi();
